import template from './info.html';
import './info.scss';

export const CheckoutInfoModule =
    angular.module('app.components.checkout.components.checkoutInfo', []).component('checkoutInfo', {
        template,
        bindings: {}
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/checkout/components/info/info.js